export const loader = {
    tag: 'div',
    classList: 'mask',
    content: `<div class="loader"></div>`,
}

